import config from '../../../config'
import { authHeader, customFetch, handleResponse, commonRequestOptions } from '../../../helpers'
import { appName } from '../appConfig'

const base = `${appName}/event_field_def`

export const eventFieldDefService = {
  getByEvent,
  create,
  update,
  remove,
}

function getByEvent(eventSlug, signal) {
  const opts = { method: 'GET', headers: authHeader(), ...commonRequestOptions() }
  return customFetch(`${config.api.url}/${base}/?event_slug=${encodeURIComponent(eventSlug)}`, opts, signal).then(handleResponse)
}

function create(payload, signal) {
  const opts = {
    method:  'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body:    JSON.stringify(payload),
    ...commonRequestOptions(),
  }
  return customFetch(`${config.api.url}/${base}/`, opts, signal).then(handleResponse)
}

function update(id, payload, signal) {
  const opts = {
    method:  'PUT',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body:    JSON.stringify(payload),
    ...commonRequestOptions(),
  }
  return customFetch(`${config.api.url}/${base}/${id}`, opts, signal).then(handleResponse)
}

function remove(id, signal) {
  const opts = {
    method:  'DELETE',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body:    JSON.stringify({}),
    ...commonRequestOptions(),
  }
  return customFetch(`${config.api.url}/${base}/${id}`, opts, signal).then(handleResponse)
}
